/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { DropdownOption } from '@ihsm/ui-shared/lib/typings/shared/components/Dropdown';

export interface UiState {
  isCollapsiblePanelCollapsed: boolean;
  isSearchTreeCollapsed: boolean;
  isSideBarCollapsed: boolean;
  showFullLoadingScreen: boolean;
  noData: boolean;
  measureType: string;
  measureTypeList: DropdownOption[];
}

export const initialUiState: UiState = {
  isCollapsiblePanelCollapsed: false,
  isSearchTreeCollapsed: false,
  isSideBarCollapsed: false,
  noData: false,
  showFullLoadingScreen: true,
  measureType: 'Abs',
  measureTypeList: [{ displayText: '', value: '' }],
};

export const uiSlice: Slice<UiState> = createSlice({
  name: 'uiSlice',
  initialState: initialUiState,
  reducers: {
    toggleSearchTreeCollapse: (state) => {
      state.isSearchTreeCollapsed = !state.isSearchTreeCollapsed;
    },
    toggleCollapsablePanelCollapse: (state) => {
      state.isCollapsiblePanelCollapsed = !state.isCollapsiblePanelCollapsed;
    },
    setSideBarCollapse: (state, action: PayloadAction<boolean>) => {
      state.isSideBarCollapsed = action.payload;
    },
    showFullLoadingView: (state, action: PayloadAction<boolean>) => {
      state.showFullLoadingScreen = action.payload;
    },
    showNoDataView: (state, action: PayloadAction<boolean>) => {
      state.noData = action.payload;
    },
    updateMeasureType: (state, action: PayloadAction<string>) => {
      state.measureType = action.payload;
    },
  },
});

export const {
  toggleCollapsablePanelCollapse,
  toggleSearchTreeCollapse,
  setSideBarCollapse,
  showFullLoadingView,
  showNoDataView,
  updateMeasureType,
} = uiSlice.actions;
